import React from "react";
import Input from "../../Components/Input";
import Btn from "../../Components/Btn/Btn";
import { BiFilterAlt } from "react-icons/bi";
import Categories from "../../Components/Categories";
import Subject from "../../Components/Subjet";
import Card from "../../Components/Card";
import { useHome } from "./Hooks";
import Loading from "../../Components/Loading";
import { BsSearch } from "react-icons/bs";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

const Home = () => {
  const { data, loading, form, setForm, navigate } = useHome();
  if (loading) {
    return (
      <div className="container">
        <div className="row">
          <Loading count={6} col={2} height="49px" />
        </div>
        <div className="row">
          <Loading col={12} count={4} />
        </div>
      </div>
    );
  }
  return (
    <div className="container mt-2">
      <div className="row">
        <div className="col-9">
          <Input
            onChange={({ target: { value } }) => {
              setForm({ ...form, search: value });
            }}
          />
        </div>
        <div className="col-3">
          <Btn
            onClick={() => {
              if (form.search) {
                navigate(`/list?search=${form.search}`);
              } else {
                navigate(`/list`);
              }
            }}
            type={"filteringBtn"}
            className="fs-10"
          >
            <BsSearch />
          </Btn>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col">
          <Categories data={data.categories} />
        </div>
      </div>

      {/* اسلایدر آگهی های تایید شده  */}
      <div className="sliderBox">
        <div className="row mb-9">
          <div className="col">
            <Subject
              title={"آگهی های تایید شده"}
            />
          </div>
        </div>

        <Swiper spaceBetween={10} slidesPerView={2}>
          {data?.verified.map((item, key) => {
            return (
              <SwiperSlide key={key}>
                <Card data={item} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>



      {/* اسلایدر آگهی های بر اساس دسته بندی  */}
      {data?.category_ads?.map((element, key) => {
        return (
          <div key={key} className="sliderBox">
            <div className="row mb-9">
              <div className="col">
                <Subject
                  title={element.title}
                  image={element.image}
                  category_id={element.id}
                />
              </div>
            </div>

            <Swiper spaceBetween={10} slidesPerView={2}>
              {element.ads_parent.map((item, key) => {
                return (
                  <SwiperSlide key={key}>
                    <Card data={item} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        );
      })}
    </div>
  );
};

export default Home;
